import axios from 'axios'
import router from '../router'
import { Message, Loading } from 'element-ui'
import { getCookie, getToken, removeToken } from '@/utils/auth'
import _this from '../main'
const token = getToken('Token') || ''
let flag = false
let isError = false
// 创建axios实例
let service = axios.create({
  // baseURL: 'https://mock.udantech.com:30095/udan-ems-api', // test env
  // baseURL: 'http://10.0.10.114:9020/udan-ems-api', // api的base_url
  // baseURL: 'http://10.0.2.77:9020/udan-ems-api', // api的base_url
  // baseURL: 'http://10.0.11.188:9020/udan-ems-api', // api的base_url
  // baseURL: 'http://10.0.10.70:9020/udan-ems-api', // api的base_url
  // baseURL: 'http://10.0.2.49:9020/udan-ems-api', //  @siyu.zhou
  // baseURL: 'http://10.0.10.156:9020/udan-ems-api', // @bofan.wang
  // baseURL: 'http://10.0.10.63:9020/udan-ems-api', // @jianbiao.zhao
  // baseURL: 'http://10.0.10.241:9020/udan-ems-api', // @qinyang.li
  // baseURL: 'http://10.0.2.131:9020/udan-ems-api', // @zhongzhong.wang
  // baseURL: 'http://10.0.2.49:9020/udan-ems-api', // @siyu.zhou
  // baseURL: 'http://10.0.2.23:9020/udan-ems-api', // @changwen.xu api的base_url
  // baseURL: 'http://10.0.2.155:9020/udan-ems-api', // api的base_url
  // baseURL: 'http://10.0.3.245:9020/udan-ems-api', // api的base_url
  // baseURL: 'https://mock.udantech.com/udan-ems-api', //
  baseURL: 'https://www.iesscloud.com/udan-ems-api', // prod env
  timeout: 50000 // 请求超时时间
})
window._axiosPromiseArr = []
// request拦截器
service.interceptors.request.use(
  (config) => {
    if (getToken('Token')) {
      if (config.isError) {
        isError = true
      } else {
        isError = false
      }
      if (config.need) {
        config.headers = {
          'x-auth': getToken('Token') || '', // 携带权限参数
          'Content-Type': 'application/json;charset=UTF-8'
        }
      } else {
        config.headers = {
          'x-auth': getToken('Token') || '', // 携带权限参数
          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        }
      }
    }
    config.cancelToken = new axios.CancelToken((cancel) => {
      window._axiosPromiseArr.push({ cancel, id: config.url })
    })
    config.headers['Accept-Language'] = getCookie('language') == 'en' ? 'en-US' : 'zh-CN' || 'zh-CN'
    return config
  },
  (error) => {
    Promise.reject(error)
  }
)
axios.defaults.headers.common['x-auth'] = token
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
// respone拦截器
service.interceptors.response.use(
  (response) => {
    /**
     * code:200,接口正常返回;
     */
    const res = response
    if (res.status === 200 && res.data.type === 'application/octet-stream') {
      return response
    }
    const code = response.data.code
    switch (code) {
      case 102:
        if (getToken('Token')) {
          removeToken('Token')
          Message({
            message: _this.$t('登录已过期，请重新登录'),
            type: 'error',
            showClose: true,
            duration: 0,
            customClass: 'stale-dated'
          })
          _this.$store.dispatch('resetAll')
          router.push('/login')
        } else {
          router.push('/login')
        }
        return Promise.reject(res.data.message)
      case 413:
        _this.$store.dispatch('resetAll')
        let loadingInstance = Loading.service({
          fullscreen: true,
          text: _this.$t('该账号已退出登录或没有资源权限即将返回登录页'),
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.8)'
        })
        // 以服务的方式调用的 Loading 需要异步关闭
        setTimeout(() => {
          loadingInstance.close()
          router.push({ path: '/login' })
        }, 2000)
        return
      case 200:
        return response
      case 129:
        if (getToken('Token')) {
          removeToken('Token')
          Message({
            message: response.data.message,
            type: 'error',
            showClose: true,
            duration: 0,
            customClass: 'stale-dated'
          })
          _this.$store.dispatch('resetAll')
          router.push('/login')
        } else {
          return response
        }
      case 2006:
        return response
      default:
        if (isError) {
          return response
        } else {
          Message({
            message: res.data.message,
            type: 'error',
            duration: 5 * 1000
          })
        }
    }
  },
  (error) => {
    var originalRequest = error.config
    if (error.code === 'ECONNABORTED' && error.message.indexOf('timeout') !== -1 && !originalRequest._retry) {
      originalRequest._retry = true
      return axios.request(originalRequest)
    }
    if (error.message != 'canceled') {
      Message({
        message: error.message,
        type: 'error',
        duration: 5 * 1000
      })
      // return {}
      return Promise.reject(error)
    }
  }
)
export default service
